import config from 'config'


export class Logger {
  static LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    NONE: 4
  };

  static currentLevel = !config.isDebug
    ? Logger.LOG_LEVELS.ERROR
    : Logger.LOG_LEVELS.DEBUG;

  static debug(...args) {
    if (this.currentLevel <= Logger.LOG_LEVELS.DEBUG) {
      console.log('[DEBUG]', ...args);
    }
  }

  static info(...args) {
    if (this.currentLevel <= Logger.LOG_LEVELS.INFO) {
      console.info('[INFO]', ...args);
    }
  }

  static warn(...args) {
    if (this.currentLevel <= Logger.LOG_LEVELS.WARN) {
      console.warn('[WARN]', ...args);
    }
  }

  static error(...args) {
    if (this.currentLevel <= Logger.LOG_LEVELS.ERROR) {
      console.error('[ERROR]', ...args);
    }
  }
}